export default "__VITE_ASSET__$04q36Ek__"